// The cheerio passes in ./index parse the body twice with parse5, which costs
// hundreds of milliseconds per changelog entry in the widget. The browser
// already has a parser, so stored HTML goes through this one instead.
export const prepareStoredHtml = (html: string): string => {
	if (typeof document === "undefined") return html

	const template = document.createElement("template")
	template.innerHTML = html
	const content = template.content

	content.querySelectorAll("a").forEach((link) => {
		link.setAttribute("target", "_blank")
		link.setAttribute("rel", "noopener noreferrer")
	})

	content.querySelectorAll("table").forEach((table) => {
		if (table.parentElement?.classList.contains("tableScroll")) return
		const wrapper = document.createElement("div")
		wrapper.className = "tableScroll"
		table.replaceWith(wrapper)
		wrapper.appendChild(table)
	})

	// A changelog list holds every entry's images at once, so the ones below the
	// fold wait until the reader gets to them.
	content.querySelectorAll("img").forEach((image) => {
		image.setAttribute("loading", "lazy")
		image.setAttribute("decoding", "async")
	})

	return template.innerHTML
}

export const htmlToPlainText = (html: string): string => {
	if (typeof document === "undefined") return html
	const template = document.createElement("template")
	template.innerHTML = html
	return template.content.textContent ?? ""
}
